var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1180,
    height: 876,
    viewBox: "0 0 1180 876",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5244_65979)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1180,
    height: 876,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 270,
    height: 98,
    rx: 6,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 531.5,
    width: 666,
    height: 330,
    rx: 5.5,
    fill: "white",
    stroke: "#E6EDF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.5,
    y: 531.5,
    width: 444,
    height: 330,
    rx: 5.5,
    fill: "white",
    stroke: "#E6EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872 373L872 463",
    stroke: "#E2E4E9",
    strokeWidth: 0.857494,
    strokeDasharray: "3.43 3.43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 26,
    width: 270,
    height: 98,
    rx: 6,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598,
    y: 26,
    width: 270,
    height: 98,
    rx: 6,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 884,
    y: 26,
    width: 270,
    height: 98,
    rx: 6,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.5,
    y: 140.5,
    width: 444,
    height: 374,
    rx: 5.5,
    fill: "white",
    stroke: "#E6EDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831 793C832.657 793 834 794.343 834 796V806C834 807.657 832.657 809 831 809H733V793H831Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103 754C1104.66 754 1106 755.343 1106 757V767C1106 768.657 1104.66 770 1103 770L733 770V754L1103 754Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932 715C933.657 715 935 716.343 935 718V728C935 729.657 933.657 731 932 731H733V715H932Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M843 676C844.657 676 846 677.343 846 679V689C846 690.657 844.657 692 843 692H733V676H843Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075 637C1076.66 637 1078 638.343 1078 640V650C1078 651.657 1076.66 653 1075 653H733V637H1075Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796 598C797.657 598 799 599.343 799 601V611C799 612.657 797.657 614 796 614H733V598H796Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 140.5,
    width: 666,
    height: 374,
    rx: 5.5,
    fill: "white",
    stroke: "#E6EDF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 557,
    width: 151,
    height: 22,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 164,
    width: 151,
    height: 22,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733,
    y: 164,
    width: 151,
    height: 22,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582,
    y: 164,
    width: 87,
    height: 22,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 481,
    y: 164,
    width: 87,
    height: 22,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733,
    y: 557,
    width: 151,
    height: 22,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 592,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 636,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 680,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 724,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 768,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 812,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 592,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 636,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 680,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 724,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 768,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 812,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 590,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 634,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 678,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 722,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 766,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 810,
    width: 187,
    height: 22,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.5,
    cy: 228.5,
    r: 21.5,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 210,
    width: 262,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 233,
    width: 71,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066,
    y: 210,
    width: 64,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.5,
    cy: 291.5,
    r: 21.5,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 273,
    width: 262,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 296,
    width: 71,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066,
    y: 273,
    width: 64,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.5,
    cy: 354.5,
    r: 21.5,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 336,
    width: 262,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 359,
    width: 71,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066,
    y: 336,
    width: 64,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.5,
    cy: 417.5,
    r: 21.5,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 399,
    width: 262,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 422,
    width: 71,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066,
    y: 399,
    width: 64,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.5,
    cy: 480.5,
    r: 21.5,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 462,
    width: 262,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 485,
    width: 71,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1066,
    y: 462,
    width: 64,
    height: 14,
    rx: 2,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 200,
    width: 617,
    height: 289,
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1192,
    height: 876,
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5244_65979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1180,
    height: 876,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBg);
export default __webpack_public_path__ + "static/media/home_BG.244eedaa0cdb8b260c85bab9d7d6e6a3.svg";
export { ForwardRef as ReactComponent };